import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_DEDUCTIONS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_DEDUCTION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_DEDUCTION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_DEDUCTION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_DEDUCTION:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
